import { removeParagraphTags } from '@portal-internet/core';
import Text from 'components/3catinfo/Text/Text';
import styles from '../cosNoticia.module.scss';
import { useViewport } from 'hooks/3catinfo/useViewport';

const setHeightSizeToIframe = (iframe, height) => {
    return /height="[^"]*"/i.test(iframe)
        ? iframe.replace(/height="([^"]*)"/i, `height="${height}"`)
        : iframe.replace(/<iframe/i, `<iframe height="${height}"`);
};

const Iframe3Cat = (props) => {
    const { text, height, height_desktop } = props;
    const { isOnlyMobile } = useViewport();
    const textHeight = setHeightSizeToIframe(removeParagraphTags(text), isOnlyMobile ? height : height_desktop);
    return <Text text={textHeight} dataTestId='cos-noticia-iframe3cat' className={styles.iframe3Cat} />;
};

export default Iframe3Cat;
